<template>
  <h2>Hello {{ username }}!</h2>
  <button class="btn btn-primary mr-2" @click="logout">Logout</button>
  <button class="btn btn-danger" @click="initialDeletion">
    Delete profile
  </button>

  <div class="mt-5 text-muted small">
    <router-link to="/imprint">Imprint</router-link> |
    <router-link to="/privacy-policy">Privacy Policy</router-link>
  </div>

  <div class="deleteConfirmation" v-if="deleteConfirmationVisible">
    <div class="card m-2 p-4 deleteConfirmationCard">
      <h4>
        Are you sure you want to delete your profile?<br />All data attached to
        your profile will be deleted too.
      </h4>
      <div class="row">
        <div class="col">
          <button
            class="btn btn-secondary"
            @click="deleteConfirmationVisible = false"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button class="btn btn-danger" @click="deleteProfile">Delete</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.deleteConfirmation {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
</style>

<script>
import { server } from "@/utils/helper";
import axios from "axios";
import router from "@/router";

export default {
  data() {
    return {
      username: "",
      sub: "",
      deleteConfirmationVisible: false,
    };
  },
  created() {
    const token = localStorage.getItem("jwt");
    if (!token) return null;
    const payload = JSON.parse(atob(token.split(".")[1]));
    this.sub = payload.sub;
    this.username = payload.username;
  },
  methods: {
    async initialDeletion() {
      this.deleteConfirmationVisible = true;
    },
    async deleteProfile() {
      const bearerToken = localStorage.getItem("jwt");
      console.log(this.sub);
      await axios
        .delete(`${server.baseUrl}/events`, {
          headers: { Authorization: "Bearer " + bearerToken },
          redact: ["authorization"],
        })
        .catch((error) => {
          console.log(error.message);
        });

      await axios
        .delete(`${server.baseUrl}/goals`, {
          headers: { Authorization: "Bearer " + bearerToken },
          redact: ["authorization"],
        })
        .catch((error) => {
          console.log(error.message);
        });

      await axios
        .delete(`${server.baseUrl}/months`, {
          headers: { Authorization: "Bearer " + bearerToken },
          redact: ["authorization"],
        })
        .catch((error) => {
          console.log(error.message);
        });

      await axios
        .delete(`${server.baseUrl}/user/${this.sub}`, {
          headers: { Authorization: "Bearer " + bearerToken },
          redact: ["authorization"],
        })
        .then(() => {
          localStorage.removeItem("jwt");
          router.push("/register");
        })
        .catch((error) => {
          console.log(error.message);
        });
    },
    logout() {
      localStorage.removeItem("jwt");
      router.push("/login");
    },
  },
};
</script>
